import { Collapse, Form } from "antd";
import { CollapseProps } from "antd/lib/collapse";
import { MetricSetting } from "./metric-setting";
import { ReportData as ReportDataV2 } from "./report-data-v2";
import { MetricTabName } from "./tab-name";
import React from "react";
import { MetricBreakDownTabsChartKeyEnum } from "@src/pages/ab-test-explore/enum/tabs-key.enum";
import { useTracking } from "react-tracking";
import { trackEventPayload } from "@src/util/track-event-payload";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { useABContext } from "@src/contexts/ab-testing/ab-context";
import { css } from "@emotion/react";

type MetricPerformanceItemProps = {
  targetKey: string;
};

export const MetricPerformanceItem: React.FC<MetricPerformanceItemProps> = ({ targetKey }) => {
  const { trackEvent } = useTracking();
  const { chartForm } = useABContext();
  const collapseItems: CollapseProps["items"] = [
    // {
    //   key: "metric",
    //   label: <MetricTabName targetKey={targetKey} />,
    //   children: <MetricSetting targetKey={targetKey} />,
    // },
    // {
    //   key: MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_ACT_DATE,
    //   label: <div>Over act date</div>,
    //   children: <UserMeasureOverActDate targetKey={targetKey} chartKey={MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_ACT_DATE} />,
    //   extra: (
    //     <ChartAction tabKey={MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_ACT_DATE} tabName="Measure over act date" form={form} />
    //   ),
    // },
    // {
    //   key: MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_COHORT_DATE,
    //   label: <div>Over cohort date</div>,
    //   children: <UserMeasureOverCohortDate targetKey={targetKey} chartKey={MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_COHORT_DATE} />,
    //   extra: (
    //     <ChartAction tabKey={MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_COHORT_DATE} tabName="Measure over cohort" form={form} />
    //   ),
    // },

    // {
    //   key: MetricBreakDownTabsChartKeyEnum.USER_PERCENTILES,
    //   label: <div>User percentiles</div>,
    //   children: <UserPercentiles targetKey={targetKey} chartKey={MetricBreakDownTabsChartKeyEnum.USER_PERCENTILES} />,
    //   extra: (
    //     <ChartAction tabKey={MetricBreakDownTabsChartKeyEnum.USER_PERCENTILES} tabName="User percentiles" form={form} />
    //   ),
    // },

    // {
    //   key: MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_DAY_DIFF,
    //   label: <div>User measure over day diff</div>,
    //   children: (
    //     <UserMeasureOverDayDiff
    //       targetKey={targetKey}
    //       chartKey={MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_DAY_DIFF}
    //     />
    //   ),
    //   extra: (
    //     <ChartAction
    //       tabKey={MetricBreakDownTabsChartKeyEnum.USER_MEASURE_OVER_DAY_DIFF}
    //       tabName="User measure over day diff"
    //       form={form}
    //     />
    //   ),
    // },

    // {
    //   key: MetricBreakDownTabsChartKeyEnum.REPORT_DATA,
    //   label: <div>Report</div>,
    //   children: <ReportData targetKey={targetKey} chartKey={MetricBreakDownTabsChartKeyEnum.REPORT_DATA} />,
    // },

    {
      key: MetricBreakDownTabsChartKeyEnum.REPORT_DATA,
      label: <div>Report</div>,
      children: <ReportDataV2 targetKey={targetKey} chartKey={MetricBreakDownTabsChartKeyEnum.REPORT_DATA} />,
    },
  ];
  const metricTabName = Form.useWatch([targetKey, ChartFormFieldsEnum.METRIC_TAB_NAME], chartForm);
  const onChange = (key: string | string[]) => {
    trackEvent(
      trackEventPayload.metricReportCardStatus(
        key.includes(MetricBreakDownTabsChartKeyEnum.REPORT_DATA) ? "card_expand" : "card_collapse",
        metricTabName,
      ),
    );
  };

  return (
    <div
      css={css`
        .ant-collapse-header {
          border-radius: 0px !important;
        }
      `}
    >
      <MetricSetting targetKey={targetKey} />
      <Collapse
        destroyOnHidden
        items={collapseItems}
        defaultActiveKey={[MetricBreakDownTabsChartKeyEnum.REPORT_DATA]}
        onChange={onChange}
      />
    </div>
  );
};
